import React from 'react';
import { find, cloneDeep } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { ACCESS_MANAGEMENT_USER_GROUPS_MODE, CREATE_USER_GROUP_TABS } from 'constants/common';
import { accessManagementUserGroupsListMode as AccessManagementUserGroupsListModeView } from 'ui/views/widgets/accessManagementUserGroupsListMode';
import { accessManagementUserGroupsCreateMode as AccessManagementUserGroupsCreateModeView } from 'ui/views/widgets/accessManagementUserGroupsCreateMode';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { accessManagementUserGroups as AccessManagementUserGroups } from 'ui/views/widgets/accessManagementUserGroups';
 *
 * // render
 * <AccessManagementUserGroups propName='propValue'/>
 */
const _accessManagementUserGroups = ( {
    componentData,
    mode,
    selectedTab,
    formData,
    selectedPermissions,
    errorMessage,
    isSearchingUsers,
    usersSearchQuery,
    userSearchResults,
    addedUsers,
    isSearchingUserGroup,
    userGroupSearchQuery,
    userGroupSearchResults,
    onCreateUserGroupActionClick,
    onCancelActionClick,
    onGoToUsersActionClick,
    onPermissionSelect,
    onSubmitFormData,
    handleListingCardActions,
    onUserSearch,
    onUserAdd,
    onUserRemove,
    onGoToInformationActionClick,
    onFormDataChange,
    onUserGroupSearch
} ) => {

    const { options, userGroups, createUserGroupSection, userGroupsListing } = componentData;
    const { searchSection, userGroupCard } = userGroupsListing;

    const selectedTabObj = cloneDeep( find( createUserGroupSection.tabs, { name: selectedTab } ) );

    if( ACCESS_MANAGEMENT_USER_GROUPS_MODE.EDIT === mode && CREATE_USER_GROUP_TABS.USERS_TAB === selectedTab ) {
        selectedTabObj.actions = selectedTabObj.updateActions; // show update button instead of submit
    }

    return (
        <div className='ui-access-management-user-groups'>

            {/* LIST MODE */}
            {
                ACCESS_MANAGEMENT_USER_GROUPS_MODE.LIST === mode && (
                    <AccessManagementUserGroupsListModeView
                        isSearchingUserGroup={ isSearchingUserGroup }
                        userGroupSearchQuery={ userGroupSearchQuery }
                        userGroupSearchResults={ userGroupSearchResults }
                        options={ options }
                        userGroups={ userGroups }
                        searchSection={ searchSection }
                        userGroupCard={ userGroupCard }
                        onCreateUserGroupActionClick={ onCreateUserGroupActionClick }
                        handleListingCardActions={ handleListingCardActions }
                        onUserGroupSearch={ onUserGroupSearch }
                    />
                )
            }

            {/* CREATE/EDIT MODE */}
            {
                ( ACCESS_MANAGEMENT_USER_GROUPS_MODE.CREATE === mode || ACCESS_MANAGEMENT_USER_GROUPS_MODE.EDIT === mode ) && (
                    <AccessManagementUserGroupsCreateModeView
                        formData={ formData }
                        selectedPermissions={ selectedPermissions }
                        errorMessage={ errorMessage }
                        isSearchingUsers={ isSearchingUsers }
                        usersSearchQuery={ usersSearchQuery }
                        userSearchResults={ userSearchResults }
                        addedUsers={ addedUsers }
                        mode={ mode }
                        createUserGroupSection={ createUserGroupSection }
                        selectedTab={ selectedTab }
                        selectedTabObj={ selectedTabObj }
                        options={ options }
                        onCancelActionClick={ onCancelActionClick }
                        onGoToUsersActionClick={ onGoToUsersActionClick }
                        onPermissionSelect={ onPermissionSelect }
                        onSubmitFormData={ onSubmitFormData }
                        onUserSearch={ onUserSearch }
                        onUserAdd={ onUserAdd }
                        onUserRemove={ onUserRemove }
                        onGoToInformationActionClick={ onGoToInformationActionClick }
                        onFormDataChange={ onFormDataChange }
                    />
                )
            }
        </div>
    );
};

// set display name
_accessManagementUserGroups.displayName = 'accessManagementUserGroups';

// set default props
_accessManagementUserGroups.defaultProps = {};

// prop types
_accessManagementUserGroups.propTypes = {};

export const accessManagementUserGroups = withNetworkState( HeartBeatPreloader, _accessManagementUserGroups );
